module.exports = __webpack_public_path__ + "img/reactjs.ddd11c2b.svg";